import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/setting/warehouse-receiving-address`;

const getAll = async () => {
  return await axios.get(API_URL);
};

const getByCustomerId = async (customerId) => {
  return await axios.get(`${API_URL}?customerId=${customerId}`);
};

const create = async (payload) => {
  return await axios.post(API_URL, payload);
};

const update = async (id, payload) => {
  return await axios.put(`${API_URL}/${id}`, payload);
};

const remove = async (id) => {
  return await axios.delete(`${API_URL}/${id}`);
};

const assignCustomer = async (warehouseReceivingAddressId, customerId) => {
  return await axios.post(`${API_URL}/assign`, { warehouseReceivingAddressId, customerId });
};

const unassignCustomer = async (warehouseReceivingAddressId, customerId) => {
  return await axios.post(`${API_URL}/unassign`, { warehouseReceivingAddressId, customerId });
};

export default {
  getAll,
  getByCustomerId,
  create,
  update,
  remove,
  assignCustomer,
  unassignCustomer,
};
